const emiPageConfig = {
  badge: "Easy Finance",
  title: "Car Loan EMI Calculator",
  subtitle:
    "Plan your monthly budget before you buy. Adjust loan amount, interest rate, and tenure to see your EMI instantly.",
  calculator: {
    defaultCarPrice: 800000,
    defaultDownPaymentPercent: 20,
    defaultInterestRate: 10.5,
    defaultTenureMonths: 60,
    minCarPrice: 50000,
    maxCarPrice: 50000000,
    minDownPaymentPercent: 0,
    maxDownPaymentPercent: 80,
    minInterestRate: 5,
    maxInterestRate: 24,
    minTenureMonths: 12,
    maxTenureMonths: 84,
    tenureStep: 6,
    currencySymbol: "₹",
  },
  fields: [
    {
      id: "carPrice",
      label: "Car Price",
      type: "currency",
      hint: "On-road or listing price of the vehicle",
    },
    {
      id: "downPaymentPercent",
      label: "Down Payment",
      type: "percent",
      hint: "Amount you pay upfront",
    },
    {
      id: "interestRate",
      label: "Interest Rate (p.a.)",
      type: "percent",
      hint: "Annual rate offered by your lender",
    },
    {
      id: "tenureMonths",
      label: "Loan Tenure",
      type: "months",
      hint: "Repayment period in months",
    },
  ],
  result: {
    emiLabel: "Estimated Monthly EMI",
    loanAmountLabel: "Loan Amount",
    downPaymentLabel: "Down Payment",
    totalInterestLabel: "Total Interest",
    totalPayableLabel: "Total Amount Payable",
    perMonthSuffix: "/month",
    disclaimer:
      "This is an indicative estimate only. Final EMI depends on bank approval, processing fees, and insurance add-ons.",
  },
  breakdown: {
    title: "Payment Breakdown",
    principalLabel: "Principal",
    interestLabel: "Interest",
  },
  tenureOptions: [
    { months: 12, label: "1 Year" },
    { months: 24, label: "2 Years" },
    { months: 36, label: "3 Years" },
    { months: 48, label: "4 Years" },
    { months: 60, label: "5 Years" },
    { months: 72, label: "6 Years" },
    { months: 84, label: "7 Years" },
  ],
  partnerPlans: {
    title: "Popular Finance Options",
    subtitle: "Sample plans from partner lenders — rates may vary",
    items: [
      {
        id: 1,
        name: "Flex EMI",
        rate: 10.5,
        tenureMonths: 60,
        highlight: "Low processing fee",
      },
      {
        id: 2,
        name: "Quick Loan",
        rate: 11.25,
        tenureMonths: 48,
        highlight: "Fast approval",
      },
      {
        id: 3,
        name: "Zero Down",
        rate: 12,
        tenureMonths: 72,
        highlight: "Minimal upfront",
      },
    ],
  },
  actions: {
    contactLabel: "Talk to Finance Expert",
    contactPath: "/contact?category=finance",
    browseLabel: "Browse Cars in Budget",
    browsePath: "/cars",
    valuationLabel: "Check Car Value",
    valuationPath: "/valuation",
  },
  highlights: [
    {
      id: 1,
      icon: "📊",
      title: "Instant Estimate",
      description: "See EMI in real time as you adjust sliders",
    },
    {
      id: 2,
      icon: "🏦",
      title: "No Bank Login",
      description: "Explore options before applying for a loan",
    },
    {
      id: 3,
      icon: "🔒",
      title: "Budget Smart",
      description: "Match monthly EMI to your comfort range",
    },
  ],
  carDetailLink: {
    path: "/finance",
    queryParam: "price",
  },
};

export default emiPageConfig;
